<p-dialog [modal]="true" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="headless">
        <div class="p-4 flex flex-col gap-5 bg-[#FFFFFF] rounded-[16px] font-[Gilroy] max-h-screen overflow-auto">

            <div class="flex w-full gap-4 mobile:gap-1 justify-between items-center">
                <p class="text-black font-semibold text-2xl mobile:text-md">
                    {{ 'locations.new_locations_detected' | transloco }}
                </p>
                <button (click)="closeModal()" title="{{ 'shared.close' | transloco }}">
                    <img src="assets/icons/close-circle-black.svg" alt="X" />
                </button>
            </div>

            <p class="text-neutral-800">
                {{ 'locations.new_locations_prompt' | transloco }}
            </p>

            @if(showFreeLocation && inactiveLocations.length == 1)
            {
            <div class="bg-neutral-100 rounded-[16px] p-4 text-neutral-800 text-sm font-medium">
                <p>
                    {{ 'locations.location_included_in_plan' | transloco }}
                </p>
            </div>
            }
            @else {
            <div class="bg-neutral-100 rounded-[16px] p-4 text-neutral-800 text-sm font-medium">
                <p>
                    {{ 'locations.additional_location_info' | transloco }}
                </p>
                <p class="text-lg font-bold mt-1">
                    {{ pricePerLocation | currency: 'EUR':'symbol':'1.2-2' }}
                </p>
            </div>}

            <ul class="flex flex-col gap-2 max-h-[400px] overflow-auto">
                <li *ngFor="let location of inactiveLocations"
                    class="border border-neutral-200 p-3 rounded-lg flex justify-between items-center">
                    <p class="text-sm text-black">
                        {{ location.street }} {{ location.number }}, {{ location.postal_code }} {{ location.city }}
                    </p>
                    <button class="text-sm text-error-500 hover:underline" (click)="deleteLocation(location)">
                        {{ 'shared.delete' | transloco }}
                    </button>
                </li>
            </ul>

            <div class="flex desktop:flex-wrap mobile:flex-col gap-3 w-full mt-2">
                <div class="desktop:flex-[1] mobile:w-full h-[50px]">
                    <app-custom-button buttonText="{{ 'locations.confirm_location_button' | transloco }}"
                        [isDisabled]="false" backgroundColor="bg-primary" textColor="text-white" fontWeight="font-bold"
                        borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200"
                        hoverBorderColor="hover:border-primary-1200"
                        (click)="confirmAllLocations()"></app-custom-button>
                </div>
                <div class="desktop:flex-[1] mobile:w-full h-[50px]">
                    <app-custom-button buttonText="{{ 'locations.cancel_button' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-white" textColor="text-neutral-800" fontWeight="font-medium"
                        hoverTextColor="hover:text-black" borderColor="border-neutral-400"
                        hoverBackgroundColor="hover:bg-neutral-200" hoverBorderColor="hover:border-neutral-200"
                        (click)="closeModal()"></app-custom-button>
                </div>
            </div>

            <div *ngIf="dialogErrorMessage" class="flex items-center text-error mt-2 text-sm">
                <img src="assets/icons/close-circle.svg" alt="{{ 'shared.components.error_icon' | transloco }}"
                    class="w-5 h-5" />
                <p class="ml-1">{{ dialogErrorMessage }}</p>
            </div>
        </div>
    </ng-template>
</p-dialog>